<template>
  <div>
    <div v-for="productClass in topologyItem.ProductClasses" :key="productClass.ManufacturingSeriesId">
      <b-form-checkbox class="ml-3" :style="'padding-left:' + paddingLeft + 'rem'" v-model="productClass.Download" @change="setDownload(productClass, productClass.Download)">
        <h4>
          {{ productClass.DisplayName }}
          <span class="smaller float-md-right mx-2"><b-badge style="font-size: 10px">Product Class</b-badge></span>
        </h4>
      </b-form-checkbox>
      <manufacturing-series
        :topologyItem="productClass" :paddingLeft="paddingLeft + 2" @checkParent="checkParent" />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import ManufacturingSeries from './manufacturing-series.vue'
@Component({
  components: {
    'manufacturing-series': ManufacturingSeries,
  },
})

export default class extends Mixins() {
  @Prop()
  public topologyItem!: any

  @Prop()
  public paddingLeft!: number

  public checkParent() {
    this.topologyItem.Download = true
    this.$emit('checkParent')
  }

  public setDownload(item: any, value: boolean) {
    if (value) {
      this.checkParent()
    }
    item.ManufacturingSeries?.forEach((ms) => {
      ms.Download = value
      ms.Products?.forEach((p) => {
        p.Download = value
      })
    })
  }
}
</script>
